import { useState, useCallback } from "react";
import { MultiSelectField, useSelectQuery } from "@smartrent/ui";
import { PaginatedResponse } from "@smartrent/hooks";
import { StyleSheet } from "react-native";

import { instance } from "@/lib/hooks";

type DropdownData = { id: string } & Record<string, any>;

interface Props {
  onChange: (selectedRecords: DropdownData[]) => void;
  filters?: Record<string, any>;
  style?: any;
}

export function GroupMultiSelect({ onChange, filters, style }: Props) {
  const [values, setValues] = useState<DropdownData[]>([]);
  const handleChange = useCallback(
    (values: any) => {
      setValues(values);
      onChange(values);
    },
    [setValues, onChange]
  );

  const selectQueryProps = useSelectQuery(
    (inputValue) => ["groups-table", { inputValue, filters }] as const,
    function fetchGroups({ queryKey, pageParam = 1 }) {
      const [, { inputValue }] = queryKey;
      return instance
        .get(`/groups-table`, {
          params: {
            marketing_name: inputValue ? inputValue : undefined,
            page: pageParam,
            ...(filters || {}),
          },
        })
        .then((response) => response.data as PaginatedResponse<DropdownData>);
    },
    {
      enabled:
        !filters?.organization_ids ||
        Boolean(
          filters?.organization_ids && filters?.organization_ids.length > 0
        ),
    },
    {
      inputDebounceInterval: 250,
    }
  );

  return (
    <MultiSelectField<DropdownData>
      style={[styles.filter, style]}
      value={values}
      onChange={handleChange}
      name="communities"
      label="Select Communities"
      getOptionValue={({ id }) => id}
      getOptionLabel={({ marketing_name }) => marketing_name}
      {...selectQueryProps}
    />
  );
}

const styles = StyleSheet.create({
  filter: {
    maxWidth: 450,
  },
});
